<template>
    <el-dialog
        :title="isEdit ? '编辑店铺价格配置' : '新增店铺价格配置'"
        :visible.sync="addDialogVisible"
        width="800px"
        modal-append-to-selector='body' 
        append-to-selector="body"
    >
        <div class="addShopConfWrap">
            <div class="">
                <el-form label-width="20%" :model="ruleForm" ref="ruleForm">
                    <el-form-item 
                        label="适配店铺:" 
                        label-width="100px" 
                        required 
                        prop="selectShopNames"
                        :rules="[
                            { required: true, message: '请选择店铺', trigger:['change','blur'] },
                        ]"
                    >
                        <el-input v-model="ruleForm.selectShopNames" placeholder="请输入内容" readonly width="300px" @click="handleShopInput"></el-input>
                    </el-form-item>
                    <el-form-item :label="`${priceConfName.sales}配置:`" label-width="100px">
                        <el-radio-group v-model="salesPrice.way">
                            <el-radio style="line-height: 30px" label="unity">取{{  priceConfName.name }}资料保存的{{ priceConfName.sales }}</el-radio>
                            <br />
                            <el-radio label="formula">
                            按公式修改： 
                            <!-- 当前价格 -->
                            <el-select v-model="salesPrice.formulaValue.priceMultiplier" width="130px">
                                <el-option :label="priceConfName.name +  priceConfName.sales" value="now"></el-option>
                                <el-option label="基础资料销售价" value="base_sales"></el-option>
                                <el-option label="基础资料市场价" value="base_market"></el-option>
                                <el-option label="基础资料成本价" value="base_purchase"></el-option>
                                <el-option label="基础资料基本售价" value="base_base_selling"></el-option>
                            </el-select>
                            X
                            <el-input-digit v-model.number="salesPrice.formulaValue.percentage" :precision="0" :max="999" nullable style="width: 80px">
                                <span>%</span>
                            </el-input-digit>
                            +
                            <el-input-digit v-model.number="salesPrice.formulaValue.addValue" :precision="2" nullable style="width: 80px">
                                <span>元</span>
                            </el-input-digit>
                            -
                            <el-input-digit v-model.number="salesPrice.formulaValue.subtractionValue" :precision="2" nullable style="width: 80px">
                                <span>元</span>
                            </el-input-digit>
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="" label-width="100px">
                        <span>
                            <span style="margin-left: 30px; font-size: 12px"> 分角处理：</span>
                            <el-radio-group v-model="salesPrice.formulaValue.formula">
                            <el-radio label="reserve">保留角和分 <span style="color: #aaa">(四舍五入)</span></el-radio>
                            <el-radio label="erase_cent_dime">抹去分和角</el-radio>
                            <el-radio label="erase_cent">抹去分</el-radio>
                            <el-radio label="unity"
                            >统一修改为xx.
                            <el-input-digit
                                v-model.number="salesPrice.formulaValue.centDime1"
                                :precision="0"
                                :min="0"
                                :maxlength="1"
                                nullable
                                style="width: 30px"
                            >
                            </el-input-digit>
                            <el-input-digit
                                v-model.number="salesPrice.formulaValue.centDime2"
                                :precision="0"
                                :min="0"
                                :maxlength="1"
                                nullable
                                style="width: 30px"
                            >
                            </el-input-digit>
                                元
                            </el-radio>
                            </el-radio-group>
                        </span>
                    </el-form-item>
                    <el-form-item label="" label-width="100px">
                        <el-checkbox v-model="isIncr"
                            >是否价格递增（为防止重复铺货，多店铺铺货可设置递增金额，按店铺顺序上架链接依次递增金额）</el-checkbox
                        >
                        <p v-if="isIncr" style="margin-left: 30px; font-size: 12px">
                            递增金额：<el-input-digit v-model.number="salesPrice.incr" :precision="2" nullable style="width: 160px">
                            <span>元</span>
                            </el-input-digit>
                        </p>
                    </el-form-item>
                    <el-form-item label="" label-width="100px" v-if="isDistributor">
                        <el-checkbox v-model="salesPrice.isCalculateFreight">分销商品价格是否附加供销运费</el-checkbox>
                        <div style="padding-left: 10px;" v-if="salesPrice.isCalculateFreight">
                            <span style="color:#333;font-size:12px;">{{priceConfName.name}}价格 + 供销运费 X </span>
                            <el-input-digit v-model.number="salesPrice.supplyFormulaValue.percentage" placeholder="请输入" nullable style="width: 60px">
                            <span>%</span>
                            </el-input-digit> + 
                            <el-input-digit v-model.number="salesPrice.supplyFormulaValue.addValue" placeholder="请输入" nullable style="width: 60px">
                            <span>元</span>
                            </el-input-digit> -
                            <el-input-digit v-model.number="salesPrice.supplyFormulaValue.subtractionValue" placeholder="请输入" nullable style="width: 60px">
                            <span>元</span>
                            </el-input-digit>
                        </div>
                    </el-form-item>
                    <template v-if="priceConfName.market">
                        <el-form-item :label="`${priceConfName.market}配置:`" label-width="100px">
                            <el-radio-group v-model="marketPrice.way">
                            <el-radio style="line-height: 30px" label="unity">取{{ priceConfName.name }}资料保存的{{ priceConfName.market }}</el-radio>
                            <br />
                            <el-radio label="formula">
                                按公式修改： 
                                <!-- 当前价格 -->
                                <el-select v-model="marketPrice.formulaValue.priceMultiplier" width="130px">
                                <el-option :label="priceConfName.name +  priceConfName.sales" value="pdd_multi_price"></el-option>
                                <el-option :label="priceConfName.name + priceConfName.market" value="now"></el-option>
                                <el-option label="基础资料销售价" value="base_sales"></el-option>
                                <el-option label="基础资料市场价" value="base_market"></el-option>
                                <el-option label="基础资料成本价" value="base_purchase"></el-option>
                                <el-option label="基础资料基本售价" value="base_base_selling"></el-option>
                                </el-select>
                                X
                                <el-input-digit v-model.number="marketPrice.formulaValue.percentage" :precision="0" :max="999" nullable style="width: 80px">
                                <span>%</span>
                                </el-input-digit>
                                +
                                <el-input-digit v-model.number="marketPrice.formulaValue.addValue" :precision="2" nullable style="width: 80px">
                                <span>元</span>
                                </el-input-digit>
                                -
                                <el-input-digit v-model.number="marketPrice.formulaValue.subtractionValue" :precision="2" nullable style="width: 80px">
                                <span>元</span>
                                </el-input-digit>
                            </el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="" label-width="100px">
                            <span>
                                <span style="margin-left: 30px; font-size: 12px"> 分角处理：</span>
                                <el-radio-group v-model="marketPrice.formulaValue.formula">
                                    <el-radio label="reserve">保留角和分 <span style="color: #aaa">(四舍五入)</span></el-radio>
                                    <el-radio label="erase_cent_dime">抹去分和角</el-radio>
                                    <el-radio label="erase_cent">抹去分</el-radio>
                                    <el-radio label="unity"
                                    >统一修改为xx.
                                    <el-input-digit
                                        v-model.number="marketPrice.formulaValue.centDime1"
                                        :precision="0"
                                        :min="0"
                                        :maxlength="1"
                                        nullable
                                        style="width: 30px"
                                    >
                                    </el-input-digit>
                                    <el-input-digit
                                        v-model.number="marketPrice.formulaValue.centDime2"
                                        :precision="0"
                                        :min="0"
                                        :maxlength="1"
                                        nullable
                                        style="width: 30px"
                                    >
                                    </el-input-digit>
                                    元
                                    </el-radio>
                                </el-radio-group>
                            </span>
                        </el-form-item>
                    </template>
                </el-form>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="addDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="handlerSave">确 定</el-button>
        </span>
        <el-dialog-select-shop
            :visible.sync="shopDialogVisible"
            :shopData="shopDialogList"
            :selected="selectedShopsUserIds"
            placeholder="店铺名称"
            @confirm="confirmSelectShop"
        ></el-dialog-select-shop>
    </el-dialog>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  props: {
    platform: String,
    priceConfName:{
      type:Object,
      default:()=> {}
    },
  },
  components:{
  },
  computed:{
    ...mapGetters(['isDistributor']),
    shopMap(){
        let map = {};
        this.shopDialogList.forEach(item => {
            map[item.id] = item;
        });
        return map;
    }
  },
  data() {
    return {
        addDialogVisible:false,
        shopDialogVisible:false,
        selectedShopsUserIds:'',
        selectedShopsShopIds:[],
        shopDialogList:[],
        isEdit:false,
        salesPrice: {
            type: 'sales',
            way: 'unity',
            incr: '',
            formulaValue: {
                priceMultiplier: 'now',
                formula: 'reserve',
                percentage: 100,
                addValue: 0,
                subtractionValue: 0,
                centDime: '',
                centDime1: 0,
                centDime2: 0,
            },
            supplyFormulaValue:{
                priceMultiplier: 'now',
                formula: 'reserve',
                percentage: 100,
                addValue: 0,
                subtractionValue: 0,
                centDime: '',
            },
            isCalculateFreight:false, // 分销商品价格是否附加供销运费
        },
        marketPrice: {
            type: 'market',
            way: 'unity',
            incr: '',
            formulaValue: {
                priceMultiplier: 'now',
                formula: 'reserve',
                percentage: 100,
                addValue: 0,
                subtractionValue: 0,
                centDime: '',
                centDime1: 0,
                centDime2: 0,
            },
        },
        isIncr: false,
        ruleForm:{
            selectShopNames:''
        },
        editIndex:null,
    };
  },
  watch: {

  },
  methods: {

    handlerSave(){
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            let { centDime1:s_centDime1,centDime2:s_centDime2 } = this.salesPrice.formulaValue
            let { centDime1:m_centDime1,centDime2:m_centDime2 } = this.marketPrice.formulaValue
            this.salesPrice.formulaValue.centDime = (s_centDime1 || 0) * 10 + (s_centDime2 || 0)
            this.marketPrice.formulaValue.centDime = (m_centDime1 || 0) * 10 + (m_centDime2 || 0)
            let params = {
                shopIds:[...this.selectedShopsShopIds],
                shopNames:this.ruleForm.selectShopNames.split(','),
                confList:[{...this.salesPrice,incr: this.isIncr ? this.salesPrice.incr : 0}]
            };
            if(this.priceConfName.market){
                params.confList.push({...this.marketPrice})
            }
            this.$emit('addShopConf', params,this.editIndex);
          } else {
            return false;
          }
        });
    },
    handleShopInput(){
        this.shopDialogVisible = true
    },
    closeDialog(){
        this.addDialogVisible = false;
    },
    openDialog(data,editIndex) {
        this.addDialogVisible = true;
        this.isEdit = false
        this.editIndex = null
        if(data){
            this.isEdit = true
            this.editIndex = editIndex
        }
        // 初始化数据
        this.initData(data);
    },
    confirmSelectShop(list) {
        let userIdList = [];
        let shopNames = [];
        console.log(list, '------list---')
        this.selectedShopsShopIds = list.map(shop => {
            userIdList.push(shop.userId)
            shopNames.push(shop.shortTitle || shop.title)
            return shop.id
        });
        this.ruleForm.selectShopNames = shopNames.join(',');
        this.selectedShopsUserIds = userIdList.join(',')
    },
    initData(data){
        this.selectedShopsUserIds = '';
        this.selectedShopsShopIds = [];
        this.salesPrice = {
            type: 'sales',
            way: 'unity',
            incr: '',
            formulaValue: {
                priceMultiplier: 'now',
                formula: 'reserve',
                percentage: 100,
                addValue: 0,
                subtractionValue: 0,
                centDime: '',
                centDime1: 0,
                centDime2: 0,
            },
            supplyFormulaValue:{
                priceMultiplier: 'now',
                formula: 'reserve',
                percentage: 100,
                addValue: 0,
                subtractionValue: 0,
                centDime: '',
            },
            isCalculateFreight:false, // 分销商品价格是否附加供销运费
        }
        this.marketPrice = {
            type: 'market',
            way: 'unity',
            incr: '',
            formulaValue: {
                priceMultiplier: 'now',
                formula: 'reserve',
                percentage: 100,
                addValue: 0,
                subtractionValue: 0,
                centDime: '',
                centDime1: 0,
                centDime2: 0,
            },
        }
        this.isIncr = false
        this.ruleForm = {
            selectShopNames: ''
        }
        if(data){
            this.isIncr = !!data.isIncr
            if(data.shopIds){
                let userIds = data.shopIds.map(id => (this.shopMap[id] || {}).userId).filter(Boolean)
                this.selectedShopsUserIds = userIds.join(',');
                this.selectedShopsShopIds = data.shopIds;
            }
            if(data.salesPrice){
                this.salesPrice = JSON.parse(JSON.stringify(data.salesPrice))
                let centDime = this.salesPrice?.formulaValue?.centDime || 0
                let centDime1 = 0
                let centDime2 = 0
                if(typeof centDime === 'number'){
                    if(centDime < 10){
                        centDime1 = 0
                        centDime2 = centDime
                    }else{
                        centDime1 = Math.floor(centDime / 10)
                        centDime2 = centDime % 10
                    }
                }
                this.salesPrice.formulaValue.centDime1 = centDime1
                this.salesPrice.formulaValue.centDime2 = centDime2
            }
            if(data.marketPrice){
                this.marketPrice = JSON.parse(JSON.stringify(data.marketPrice))
                let centDime = this.marketPrice?.formulaValue?.centDime || 0
                let centDime1 = 0
                let centDime2 = 0
                if(typeof centDime === 'number'){
                    if(centDime < 10){
                        centDime1 = 0
                        centDime2 = centDime
                    }else{
                        centDime1 = Math.floor(centDime / 10)
                        centDime2 = centDime % 10
                    }
                }
                this.marketPrice.formulaValue.centDime1 = centDime1
                this.marketPrice.formulaValue.centDime2 = centDime2
            }
            if(data.shopNames){
                this.$set(this.ruleForm,'selectShopNames',data.shopNames.join(','))
            }
        }
        if(this.shopDialogList.length === 0){
            this.initShopList()
        }
    },
    initShopList(){
        let shopList =  this.$store.getters.get_AllShops_BySource(this.platform);
        if(this.platform === 'fxg') {
            shopList = [...shopList, ...this.$store.getters.get_AllShops_BySource('fxg_gx')];
        }
        this.shopDialogList = shopList
    }
  },
  created(){
    this.initShopList()
    // this.shopDialogList = shopList.filter(shop => [2, 3].includes(shop.state) && shop.isDeadline !== 1)
  }
};
</script>

<style lang="scss">

</style>